import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {IAdsSettings} from "../../definitions";
import {isUndefined} from "util";
import {WatchService} from "../../services/watch.service";
import {paramsHelper} from "../../helpers/params-helper";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {DOCUMENT_TYPES} from "../../enums/enums";
import {CollectionService} from "../../services/collection.service";
import {Subject} from "rxjs/Subject";

@Component({
  selector: 'nv-ads-settings',
  templateUrl: './nv-ads-settings.component.html',
  styles: []
})
export class NvAdsSettingsComponent implements OnInit, OnDestroy {

  @Input() document:IAdsSettings;
  geoToAdd:string='ru';
  ISgeoToAdd:string='ru';
  YANgeoToAdd:string='ru';
  loadedGeosList:any[] = [
    {lang:"ru"},
    {lang:"en"}
  ]

  private _selectedGeo:any;
  private _selectedISGeo:any;
  private _selectedYANGeo:any;
  private unsubscribe: Subject<void> = new Subject<void>();

  get selectedGeo():any { return this._selectedGeo; }

  get selectedISGeo():any { return this._selectedISGeo; }

  get selectedYANGeo():any { return this._selectedYANGeo; }

  constructor(private watchService:WatchService,
              private collectionService:CollectionService) { }

  ngOnInit() {
    this.loadLocalesList();
  }

  ngOnDestroy(){
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  loadLocalesList(){
    const params = paramsHelper
      .loader()
      .setEndpointId(E_ENDPOINTS.API)
      .setSearchParams(paramsHelper.search()
        .addParam("_type", SEARCH_PROP_TYPES.STRING,
          DOCUMENT_TYPES.GEO).json
      )
      .setNavParams(0, 9999);

    this.collectionService.loadChunkCached(params)
      .takeUntil(this.unsubscribe)
      .subscribe(r => {
        this.loadedGeosList = r.documents;
        if (this.loadedGeosList.length > 0)
        {
          this.geoToAdd = this.loadedGeosList[0].lang;
          this.ISgeoToAdd = this.loadedGeosList[0].lang;
          this.YANgeoToAdd = this.loadedGeosList[0].lang;
        }
      });
  }

  onAddClick(){
    if (isUndefined(this.document.geos))
    {
      this.document.geos = [];
    }
    console.log(this.document.geos.filter(geo => geo.lang == this.geoToAdd));
    if (this.document.geos.filter(geo => geo.lang == this.geoToAdd).length == 0)
    {
      this.document.geos.push({lang:this.geoToAdd, nets:[]});
      this.watchService.notify();
    }
  }

  onAddISClick(){
    if (isUndefined(this.document.ISgeos))
    {
      this.document.ISgeos = [];
    }
    console.log(this.document.ISgeos.filter(geo => geo.lang == this.ISgeoToAdd));
    if (this.document.ISgeos.filter(geo => geo.lang == this.ISgeoToAdd).length == 0)
    {
      this.document.ISgeos.push({lang:this.ISgeoToAdd, nets:[]});
      this.watchService.notify();
    }
  }

  onAddYANClick(){
    if (isUndefined(this.document.YANgeos))
    {
      this.document.YANgeos = [];
    }
    console.log(this.document.YANgeos.filter(geo => geo.lang == this.YANgeoToAdd));
    if (this.document.YANgeos.filter(geo => geo.lang == this.YANgeoToAdd).length == 0)
    {
      this.document.YANgeos.push({lang:this.YANgeoToAdd, nets:[]});
      this.watchService.notify();
    }
  }

  getGeoLabel(g){
    return g.nets.length > 0 ? `${g.lang} (${g.nets.join(", ")})` : g.lang;
  }

  onGeoSelected(item){
    this._selectedGeo = item;
  }

  onGeoSelectedIS(item){
    this._selectedISGeo = item;
  }

  onGeoSelectedYAN(item){
    this._selectedYANGeo = item;
  }

  isWaterfallEnabled(): boolean {
    return this.document.waterfallEnabled;
  }

  isIronSourceEnabled(): boolean {
    return this.document.ironSourceEnabled;
  }

  isYANEnabled(): boolean {
    return this.document.YANEnabled;
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-ads-settings/nv-ads-settings.component.ts